import axios from "axios";
import { api } from "@/api";

// https://docs.turuc.com.py/docs/api/introduccion-api
const TURUC_API_BASE = "https://turuc.com.py/api";

interface Pais {
    id: string;
    nombre: string;
    codigo: string;
}

/**
 * Obtener pais por codigo ISO (ej: "PRY" para Paraguay)
 */
export async function getPaisByCodigo(codigo: string): Promise<Pais | null> {
    try {
        const response = await api.get<Pais>(`paises/codigo/${codigo}`);
        return response.data;
    } catch (error: any) {
        if (error.response?.status === 404) {
            return null;
        }
        throw error;
    }
}

/**
 * Respuesta de la API de TuRuc para un contribuyente
 */
export interface TurucContribuyente {
    doc: number;
    razonSocial: string;
    dv: number;
    ruc: string;
    estado: string;
    esPersonaJuridica: boolean;
    esEntidadPublica: boolean;
}

/**
 * Respuesta de busqueda de TuRuc
 */
export interface TurucSearchResponse {
    data: {
        contribuyentes: TurucContribuyente[];
        paginas: number;
    };
    message: string;
}

/**
 * Respuesta de consulta por RUC de TuRuc
 */
export interface TurucGetResponse {
    data: TurucContribuyente | null;
    message: string;
}

/**
 * Buscar contribuyentes en TuRuc por termino de busqueda
 * @param search Término de búsqueda (3-50 caracteres)
 * @param page Número de página (base 0)
 */
export async function searchTurucContribuyentes(
    search: string,
    page: number = 0
): Promise<TurucSearchResponse> {
    if (!search || search.length < 3) {
        return {
            data: { contribuyentes: [], paginas: 0 },
            message: "El término de búsqueda debe tener al menos 3 caracteres"
        };
    }

    try {
        const response = await axios.get<TurucSearchResponse>(
            `${TURUC_API_BASE}/contribuyente/search`,
            {
                params: { search, page }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error buscando en TuRuc:", error);
        throw error;
    }
}